import React from 'react';
import { BookOpen, ExternalLink, GraduationCap, Award, Clock } from 'lucide-react';

const LearningSection = () => {
  const learningPlatforms = [
    {
      name: 'Udemy',
      description: 'Free courses on web development, data science, and business skills',
      link: 'https://www.udemy.com/courses/free/',
      icon: <GraduationCap className="w-6 h-6" />,
      courses: '10,000+ free courses'
    },
    {
      name: 'Coursera',
      description: 'Free courses from top universities and companies',
      link: 'https://www.coursera.org/courses?query=free',
      icon: <BookOpen className="w-6 h-6" />,
      courses: 'Free courses available'
    },
    {
      name: 'edX',
      description: 'Free online courses from MIT, Harvard, and more',
      link: 'https://www.edx.org/free-online-courses',
      icon: <Award className="w-6 h-6" />,
      courses: 'University-level courses'
    },
    {
      name: 'Khan Academy',
      description: 'Free courses on programming, business, and more',
      link: 'https://www.khanacademy.org/',
      icon: <GraduationCap className="w-6 h-6" />,
      courses: '100% free forever'
    },
    {
      name: 'Codecademy',
      description: 'Free coding courses and tutorials',
      link: 'https://www.codecademy.com/catalog/subject/web-development',
      icon: <BookOpen className="w-6 h-6" />,
      courses: 'Free coding courses'
    },
    {
      name: 'YouTube Learning',
      description: 'Free tutorials and educational content',
      link: 'https://www.youtube.com/learning',
      icon: <Clock className="w-6 h-6" />,
      courses: 'Unlimited free content'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Free Learning Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Enhance your skills with free courses from top platforms. Build your career with quality education at no cost.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {learningPlatforms.map((platform, index) => (
            <a
              key={index}
              href={platform.link}
              target="_blank"
              rel="noopener noreferrer"
              className="card hover:shadow-lg transition-all duration-300 hover:scale-105 group"
            >
              <div className="flex items-start gap-4">
                <div className="bg-primary-100 p-3 rounded-lg text-primary-600 group-hover:bg-primary-200 transition-colors">
                  {platform.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-xl font-semibold text-gray-900">{platform.name}</h3>
                    <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-primary-600 transition-colors" />
                  </div>
                  <p className="text-gray-600 mb-2 text-sm">{platform.description}</p>
                  <p className="text-primary-600 text-sm font-medium">{platform.courses}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            All platforms offer free courses to help you advance your career
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
            <span>✓ No credit card required</span>
            <span>✓ Self-paced learning</span>
            <span>✓ Certificates available</span>
            <span>✓ Expert instructors</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearningSection;

